import React from 'react';
import { Col, ContentContainer, Row, Heading, SectionHeader,
    IconNotificationError ,Button} from '@snsw-gel/react';
import styles from './AgeError.module.scss';

const AgeErrorPage = () => {

    return (
        <>
            <SectionHeader className={ styles['heading-section'] }
                label='Apply for a NSW Seniors Card or NSW Senior Savers Card '>
                <Heading level={ 1 }>
                    <IconNotificationError/>
                        You are not eligible
                </Heading>
            </SectionHeader>

            <ContentContainer className={ styles['content-container'] }>
                <Row>
                    <Col span={ 9 }>
                        <p>People who are eligible include people:</p>
                        <ul><li>aged 60 and over</li>
                            <li>turning 60 within the next 3 weeks.</li> </ul>
                    </Col>
                </Row>
                <Button
                    className={ styles['eligibility-button'] }
                    variant='primary'
                    aria-label='Check eligibility guidelines'
                    onClick={ ()=>window.location.href='https://www.service.nsw.gov.au/transaction/apply-for-a-nsw-seniors-card-or-nsw-senior-savers-card#eligibility' }
                >
                       Check eligibility guidelines
                </Button>
                <Button
                    className={ styles['home-button'] }
                    variant='secondary'
                    aria-label='Go to Service New South Wales homepage'
                    onClick={ ()=>window.location.href='https://www.service.nsw.gov.au/' }>Go to Service NSW homepage
                </Button>
            </ContentContainer>
        </>
    );
};
export default AgeErrorPage;
